import React, { useEffect } from 'react'
import MasterLayout from "../../masterLayout/MasterLayout";
import Loader from "../../components/Loader";
import FormTorneos from "../../components/torneos/FormTorneos";
import useTorneosStore from "../../store/torneosStore";
import { useNavigate, useParams } from "react-router-dom";

const DetalleTorneo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, iniciar, setNavigate, actualizarId } = useTorneosStore();
  
  useEffect(() => {
    setNavigate(navigate);
    actualizarId(id);
    iniciar();
  }, []);
  
  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <FormTorneos/> }
      </MasterLayout>
    </>
  )
}

export default DetalleTorneo
